import DateFormat from "../common/dateFormat/DateFormat";

const INITIAL_STATE = { 
    registro: {}, 
    modoTela: 'lista', 
	aguardando: false,
    lista: [], 
    filtro: {
        data_inicial: DateFormat.formatarDataSqlParaTela(DateFormat.getTimestampParaData(new Date().getTime() - 2592000000)),
        data_final: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual())
    },
    listaMotorista: [],
    listaVeiculo: [],
    listaCliente: [],
    listaEndereco: [],
    listaFreteDeslocamento: [],
    listaUnidadeMedida: [],
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'FRETE_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};
        
        case 'FRETE_SET_AGUARDANDO':
            return { ...state,
                aguardando: action.payload
            };
		
		case 'FRETE_SET_FILTRO':
			return { ...state,
				filtro: action.payload
			};

        case 'FRETE_LISTADO':
            return { ...state, lista: action.payload.data };

        case 'FRETE_MOTORISTA_SELECT_LISTADO':
			return {
				...state,
				listaMotorista: action.payload.data
            };

        case 'FRETE_VEICULO_SELECT_LISTADO':
			return {
				...state,
				listaVeiculo: action.payload.data
            };

        case 'FRETE_CLIENTE_SELECT_LISTADO':
			return {
				...state,
				listaCliente: action.payload.data
            };

        case 'FRETE_ENDERECO_SELECT_LISTADO':
			return {
				...state,
				listaEndereco: action.payload.data
            };

        case 'FRETE_DESLOCAMENTO_SELECT_LISTADO':
			return {
				...state,
				listaFreteDeslocamento: action.payload.data
            };

        case 'FRETE_UNIDADE_MEDIDA_SELECT_LISTADO':
			return {
				...state,
				listaUnidadeMedida: action.payload.data
            };

                      
        default:
            return state;
    }
}
